<template>
    <!-- Home Banner -->
    <section class="section">
        <!--=============== HEADER ===============-->
        <header class="header-home">
            <nav class="nav-home container">
                <div class="nav_data">
                    <a href="#" class="nav_logo">
                        <img src="@/assets/talento_agv/img/LOGO BLANCO.png" alt="">
                    </a>

                    <div class="nav_toggle" id="nav-toggle">
                        <i class='bx bx-menu-alt-right nav_toggle-menu'></i>
                        <i class='bx bx-x nav_toggle-close'></i>
                    </div>
                </div>
                <!--=============== NAV MENU ===============-->
                <div class="nav_menu" id="nav-menu">
                    <ul class="nav_list">
                        <li>
                            <a href="#quienes-somos" class="nav_link" @click="closeMenu">{{ $t('Quiénes somos') }}</a>
                        </li>

                        <li>
                            <router-link to="/nuestra_cultura" class="nav_link" @click="closeMenu">{{ $t('Cultura') }}</router-link>
                        </li>

                        <li>
                            <router-link to="/young_talent" class="nav_link" @click="closeMenu">Young Talent</router-link>
                        </li>
                        <li>
                            <router-link to="/escuela_corporativa" class="nav_link" @click="closeMenu">{{ $t('Escuela Corporativa') }}</router-link>
                        </li>

                        <li class="dropdown__item" @click="dropdownItemsEvent()">
                            <div class="nav__link dropdown__button">
                                {{ textLenguage }} <i class='bx bx-chevron-down dropdown__arrow'></i>
                            </div>

                            <div id="dropdown-container" class="dropdown__container small">
                                <div class="dropdown__content">
                                    <div class="dropdown__group small">
                                        <ul class="dropdown__list">
                                            <li class="dropdow-li" @click="changeLanguage('es')">
                                                <a href="javascript:;" class="dropdown__link"> ES | Español</a>
                                            </li>
                                            <li class="dropdow-li" @click="changeLanguage('en')">
                                                <a href="javascript:;" class="dropdown__link">EN | English</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <router-link to="/login" class="btn btn-agv pt-2" tabindex="-1"
                                style="color:white; padding: 10px 15px; box-shadow: 0 0 5px #fff;">
                                {{ $t('Iniciar Sesión') }}
                            </router-link>
                        </li>


                    </ul>
                </div>
            </nav>
        </header>

        <div class="banner-home-header">
            <div class="container-header">
                <div id="slide">
                    <div loading="lazy" v-for="(item, index)  in dataImagen" class="item"
                        :style="'background-image: url(' + item + ');'" :class="{'active': index === currentImageIndex, 'inactive': index !== currentImageIndex}">
                    </div>
                </div>
            </div>

            <div class="sobrefondo"></div>

            <div class="contenedor_text_banner">
                <div class="banner-kofe">
                    <div class="banner-content aos text-center" data-aos="fade-up" data-aos-duration="500">
                        <div class="typewriter-container">
                            <span id="typewriter">{{ currentTypedText }}</span>
                        </div>
                        <h2 class="titulo_banner-home" style="text-align: start !important;">{{ currentContentText }}</h2>
                        <form class="form" name="store" id="store" method="post"  @submit.prevent="submitSearch">
                            <div class="form-inner border-radius-5 bg-pleace">
                                <div class="input-group border-radius-5 bg-pleace">
                                    <span class="drop-detail">
                                        <vue-select :options="searchOptions" id="projectsone"
                                            placeholder="Seleccionar" />
                                    </span>
                                    <input type="text" class="form-control bg-pleace"
                                        placeholder="Busqueda por palabra clave ..." v-model="palabra_clave">
                                    <router-link
                                        :to="{ path: '/ofertas_laborales', query: { search_word: palabra_clave } }"
                                        class="btn-search-home" tabindex="-1"><i class='bx bx-search'></i></router-link>
                                    <router-link
                                      :to="{ path: '/ofertas_laborales' }"
                                      class="btn-search-home" style="border-left: 1px white solid; width: 120px; padding-left: 20px; padding-right: 20px;" tabindex="-1">Trabajos</router-link>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Quienes Somos -->
    <section id="quienes-somos" class="section review mb-5 quienes_somos" style="position:relative; z-index:3">
        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-ms-6 col-lg-6">
                    <div class="aos" data-aos="fade-up" data-aos-duration="500">
                        <div class="demand-professional">
                            <h2 class="mt-5 mb-4 title-acerca">{{ section_one.title }}</h2>
                            <p class="description-acerca">{{ section_one.text }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-ms-6 col-lg-6">
                    <div class="" data-aos="fade-right" data-aos-duration="500">
                        <img :src="section_one.s3_url" alt="Img" class="img-fluid img-border" style="z-index:30" />
                    </div>
                </div>
            </div>
        </div>
        <img class="vector-rayas img-acerca-fondo" src="@/assets/img/Logo gris para web-01-right.png" alt=""
            style="position:absolute; z-index: 50; height: 60%; top:0; left:0; margin-bottom: -50px; transform: rotate(180deg);">
        <img class="vector-rayas img-acerca-fondo" src="@/assets/img/Logo gris para web-01-right.png" alt=""
            style="position:absolute; z-index: 50; height: 60%; bottom:0; right:0;">
    </section>

    <!-- Nuestra Misión -->
    <section class="section company-hire mt-5 nuestros_mision"
        :style="{ 'background-image': `url(${require('@/assets/talento_agv/img/portada_banner_principal.jpg')})`, 'position': 'relative' }">
        <div class="container position-relative" data-aos="fade-down" data-aos-duration="500" style="z-index: 2;">
            <div class="row">
                <div class="col-12">
                    <div class="section-header hire-heading section-header-three text-center aos">
                        <h3 class="header-title" style="color:#fff">
                            {{ section_eight.title }}
                        </h3>
                        <p class="text-white"> {{ section_eight.subtitle }}
                        </p>
                    </div>
                </div>
            </div>

            <div id="company-slider" class="testimonial-slider aos text-center"
                style="display: flex; justify-content: center">
                <div class="row">
                    <div v-for="ind in section_eight.indicadores" class="col-xl-3 col-md-6 col-sm-3 aos" data-aos="zoom-in" data-aos-duration="1000">
                        <div class="feature-content course-count">
                            <h1>
                                {{ ind.pieces.pic[0] }}<vue3-autocounter class="counter-up" ref="counter" :startAmount="0" :delay="6"
                                    :endAmount="parseInt(ind.pieces.val[0])" :duration="3" separator="," :autoinit="true" />{{ ind.pieces.pic[1] }}
                            </h1>
                            <div class="feature-content-description" style="min-width: 200px;">
                                <p>{{ ind.subtitle }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="sobrefondo" style=""></div>
    </section>

    <!-- Cultura -->
    <section class="section platform-location">
        <div class="container">
            <div class="row">
                <div class="col-md-12 col-sm-12 col-12 mx-auto">
                    <div class="section-header section-header-four section-locate aos" data-aos="fade-up">
                        <div class="text-center">
                            <h3 class="header-title header-page-event">
                                <img class="imag-arrow" src="@/assets/talento_agv/img/arrow.png" alt="">
                                {{ $t('Vivimos nuestra') }} <span class="bg-sky-blue">{{ $t('#CulturaAgrovision') }}</span> {{ $t('en nuestros') }} <span
                                    class="bg-green">{{ $t('campos, packing y oficinas') }}</span>
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
            <div class="carousel-cultura">
                <Carousel :autoplay="2000" :wrap-around="true">
                    <Slide v-for="slide in dataCulturaCarousel" :key="slide.column">
                        <div class="grid-container">
                            <div v-for="img in slide.img" class="grid-item">
                                <img :src="`${img.ruta}`" alt="" srcset="">
                            </div>
                        </div>
                    </Slide>
                </Carousel>
            </div>
        </div>
    </section>
    <!-- / Company Hire -->

    <!-- Video -->
    <section class="section platform-location container-video">
        <video class="video-silde active" v-show="controlVideo" ref="videoPlayer1" :src="section_ten.s3_video_url" autoplay muted loop />
        <div class="container-block-video">
            <div class="row">
                <!-- <div class="col-12 col-md-6">
                </div> -->
                <div class="col-12">
                    <div class="container-play">
                        <a data-bs-toggle="modal" href="#videoHome">
                            <div class="container-icon-Video">
                                <i class='bx bx-play'></i>
                            </div>
                            <div>{{ $t('Ver el video') }}</div>
                        </a>
                    </div>
                    <div class="container-search-video">

                        <router-link :to="{ path: '/ofertas_laborales', query: { search_word: palabra_clave } }"
                            class="" tabindex="-1">
                            <div class="container-icon-Video">
                                <i class='bx bx-search'></i>
                            </div>
                            <div>{{ $t('Ver las ofertas aquí') }}</div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Nuestros Valores -->
    <section class="section company-hire nuestros_valores" style="position:relative">
        <div class="container" data-aos="fade-down" data-aos-duration="500">
            <div class="row">
                <div class="col-12">
                    <div class="section-header hire-heading section-header-three text-center aos">
                        <!-- <h2>Nue<span class="subrayado-dos">stros Valo</span>res</h2> -->
                        <h3 class="header-title" style="color:#fff">{{ $t('Nuestros Valores') }}
                        </h3>
                    </div>
                </div>
            </div>
            <!-- <div id="company-slider" class="owl-carousel owl-theme testimonial-slider aos"> -->
            <div id="company-slider" class="testimonial-slider aos text-center"
                style="display: flex; justify-content: center">
                <div class="values" v-for="item in dataTableValues" :key="item.id">
                    <div class="company-logos">
                        <img :src="item.s3_url" class="img-fluid flip" style="width:195px" alt="img">
                        <!-- <span>{{item.description}}</span> -->
                    </div>
                </div>
            </div>
        </div>
    </section>


    <!-- Noticia -->
    <section class="section platform-location">
        <div class="container">
            <div class="row">
                <div class="col-md-12 col-sm-12 col-12 mx-auto">
                    <div class="section-header section-header-four section-locate aos" data-aos="fade-up">
                        <div class="text-center">
                            <h3 class="header-title header-page-event">

                               
                                    <img class="imag-arrow" src="@/assets/talento_agv/img/arrow.png" alt="">
                                    {{ $t('Últimas') }} <span class="bg-sky-blue">{{ $t('noticias') }}</span> {{ $t('que nos llenan de') }} <span
                                        class="bg-sky-blue">{{ $t('orgullo') }}</span>
                                
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
            <div class="carousel-cultura">
                <div class="row">
                    <div v-for="items in dataNoticia" class="col-md-4 col-12 mb-5">
                        <a :href="items.url" class="card card-bg-noticias" style="border: .4rem solid var(--bg-primary) !important;" target="_blank">
                            <div class="card-body">
                                <div class="container-img-card">
                                    <img :src="items.img" alt="" srcset="">
                                </div>
                                <div class="container-card-home">
                                    <div class="card-title mb-4">
                                        <h3 class="bg-sky-blue">{{ items.title }}</h3>
                                    </div>
                                    <div class="card-text-description">
                                        <p>{{ items.description }}</p>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>

                    <div class="col-12 d-flex align-items-center justify-content-center">
                        <div class="btn-more-news">
                            <a href="https://www.linkedin.com/company/agrovisionperu/life/88e5da54-8d05-4e09-a2a5-ca6a973dbcc5/?viewAsMember=true"
                                target="_blank">Ver más</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Crear Cuenta-->
    <section class="section job-register">
        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="register-job-blk">
                        <div class="job-content-blk aos" data-aos="fade-up" data-aos-duration="500">
                            <h2>{{ section_six.title }}</h2>
                            <p>{{ section_six.subtitle }}</p>
                            <router-link to="/crear_cuenta" class="btn all-btn">Crear Cuenta</router-link>
                            <router-link to="/login" class="btn all-btn  ms-3">Ingresar</router-link>
                        </div>
                        <div class="see-all mt-0 aos opportunity" data-aos="zoom-in" data-aos-duration="700">
                            <img :src="section_six.s3_url" alt="img">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div class="modal fade" id="videoHome" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
        <div class="modal-dialog modal-xl modal-dialog-centered">
            <div class="modal-content modal-transparent">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalToggleLabel"></h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="closeVideo"></button>
                </div>
                <div class="modal-body">
<!--                    <video src="@/assets/talento_agv/video/welcome_agrovision.mp4" preload="auto" controls=""-->
<!--                        style="width: 100%; height: 100%;"></video>-->
                  <video :src="section_ten.s3_video_url" preload="auto" @canplay="updatePause" @playing="updatePause" @pause="updatePause" ref="videoPlayer2" controls
                         style="width: 100%; height: 100%;"></video>
                </div>

            </div>
        </div>
    </div>
    <!-- Pie de Página -->
    <footeragv></footeragv>

</template>

<script>
// import { defineComponent } from 'vue'
import axiosIns from '@/plugins/axios.js';
import { nextTick } from 'vue';
import { mapActions } from 'vuex';
import { Carousel, Pagination, Slide, Navigation } from 'vue3-carousel'

import 'vue3-carousel/dist/carousel.css'
import { ref } from "vue";
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
import { router } from "@/router";
import { Modal } from 'bootstrap';
import 'quill/dist/quill.snow.css';

export default {
    data() {
        return {
            dataNoticia: [
            ],
            dataCulturaCarousel: [
            ],
            // dataImagen: [img1, img2, img3, img4],
            videoControl: null,
            dataImagen: [],
            currentImageIndex: 0,
            currentTypedText: '',
            currentContentText: '',
            typingSpeed: 100,
            typingIndex: 0,
            effectText: [
                "¡Crece con nosotros!",
                "Únete a nuestro equipo.",
                "Haz que cada día cuente."
            ],
            dotPosition: ref("right"),
            searchOptions: ["Puesto", "Lugar"],
            settings: {
                itemsToShow: 1,
                snapAlign: "center",
            },
            breakpoints: {
                575: {
                    itemsToShow: 2,
                    snapAlign: "center",
                },
                767: {
                    itemsToShow: 3,
                    snapAlign: "center",
                },
                991: {
                    itemsToShow: 3,
                    snapAlign: "center",
                },
                1024: {
                    itemsToShow: 6,
                    snapAlign: "start",
                },
            },

            section_one: [],
            section_two: [],
            section_three: [],
            section_four: [],
            section_five: [],
            section_six: [],
            section_seven: [],
            section_eight: {
              indicadores: []
            },
            section_ten: [],

            dataTableValues: [],
            dataTableCards: [],

            language: null,
            textLenguage: 'es',
            palabra_clave: '',
            videoPlayer1: ref(null),
            videoPlayer2: ref(null),
            controlVideo: true,
        }
    },
    watch: {
        // videoPlayer2(){
        //     console.log('videoPlayer2', this.videoPlayer2);
        // },
        // controlVideo(){
        //     console.log('controlVideo', this.controlVideo);
        // }
    },
    async mounted() {
        // console.log(this.$i18n.locale)
        const script = document.createElement('script');
        script.src = 'https://player.vimeo.com/api/player.js';
        document.body.appendChild(script);

        await this.getMainPageData()
        await this.getValues()
        await this.getCards()
        // this.showMenu('nav-toggle', 'nav-menu')
        this.toggleImages()
        this.startTypingEffect();
        // this.videoPlayer2 = new Modal(document.getElementById('videoHome'));

        AOS.init({ duration: 1000 });
    },
    autoplay: '1',
    components: {
        Carousel,
        Slide,
        Modal,
        Pagination,
        Navigation
    },

    methods: {
        ...mapActions(['changePublicLanguage']),
        changeLanguage(language) {
            this.textLenguage = language
            this.changePublicLanguage(language);
            this.getMainPageData()
            console.log(language)
            this.$i18n.locale = language; 
        },
        updatePause(event){
            this.videoPlayer2 = event.target;
        },
        closeVideo(){
            this.videoPlayer2.pause()
        },

        closeMenu() {
            const navMenu = document.getElementById("nav-menu");
            navMenu.classList.remove("show-menu");

            const navIcon = document.getElementById("nav-toggle");
            navIcon.classList.remove("show-icon");
        },

        openInNewTab(event) {
            const routeData = this.$router.resolve({
                path: '/escuela_corporativa',
            });
            window.open(routeData.href, '_blank');
        },

        submitSearch() {
            // this.$router.push({ path: '/ofertas_laborales', query: { search_word: this.palabra_clave } });
          router.replace('/ofertas_laborales?search_word='+encodeURIComponent(this.palabra_clave))
        },

        async getMainPageData() {
            const yo = this
            const config = {
                method: 'get',
                url: '/talentoagv/getMainPageData/',
            }

            if (this.$store.getters.currentPublicLanguage == 'es') {
                yo.language = '1'
            }
            else if (this.$store.getters.currentPublicLanguage == 'en') {
                yo.language = '2'
            }

            await axiosIns(config)
                .then(function (response) {
                    console.log(response.data['result']);
                    if (response.data['is_error'] === false) {
                        let resultado = response.data['result']
                        let phrases = []
                        let indicadores = []
                        let sliders = []
                        let content = { id: 0, title: '' }
                        let carousel = []
                        let notices = []
                        for (let r of resultado) {
                            if (r['idlanguage'] == yo.language) {
                                if(r['section'] == 'cero' && r['idpage']=='1'){
                                  if(r.text != "" && r.text != null){
                                    phrases.push(r.text)
                                  }
                                  if(r.text_two != "" && r.text_two != null){
                                    content = { id: r.idcontent, title: r.text_two }
                                  }
                                  yo.section_zero = r
                                }
                                if (r['section'] == 'uno' && r['idpage'] == '1') {
                                    yo.section_one = r
                                    console.log("seccion uno",r)
                                } else if (r['section'] == 'dos' && r['idpage'] == '1') {
                                    yo.section_two = r
                                }
                                else if (r['section'] == 'tres' && r['idpage'] == '1') {
                                    yo.section_three = r
                                }
                                else if (r['section'] == 'cuatro' && r['idpage'] == '1') {
                                    yo.section_four = r
                                }
                                else if (r['section'] == 'cinco' && r['idpage'] == '1') {
                                    yo.section_five = r
                                }
                                else if (r['section'] == 'seis' && r['idpage'] == '1') {
                                    yo.section_six = r
                                }
                                else if(r['section'] == 'siete' && r['idpage']=='1'){
                                  // yo.section_seven = r
                                  sliders.push(r)
                                  yo.dataImagen.push(r.s3_url_two)
                                }
                                else if (r['section'] == 'ocho' && r['idpage'] == '1') {
                                  if(r.title_two != "" && r.title_two != null){
                                    indicadores.push({ title: r.title_two, subtitle: r.subtitle_two, id: r.idcontent, pieces: yo.extractNumber(r.title_two) })
                                  }else {
                                    yo.section_eight = r
                                  }
                                }
                                else if(r['section'] == 'nueve' && r['idpage']=='1'){
                                  if(carousel.length < 6) {
                                    carousel.push({ruta: r.s3_url_two})
                                  }else{
                                    yo.dataCulturaCarousel.push({
                                      columna: yo.dataCulturaCarousel.length+1,
                                      img: carousel
                                    })
                                    carousel = []
                                    carousel.push({ruta: r.s3_url_two})
                                  }
                                }
                                else if(r['section'] == 'diez' && r['idpage'] == '1'){
                                  yo.section_ten = r
                                }
                                else if(r['section'] == 'once' && r['idpage'] == '1'){
                                  notices.push({ img: r.s3_url, title: r.title, url: r.subtitle, description: r.text })
                                }
                            }
                        }
                        yo.section_eight['indicadores'] = indicadores
                        // console.log("informacion nuestra vision", yo.section_eight)
                        yo.section_seven = sliders
                        yo.effectText = phrases
                        yo.currentContentText = content.title
                        yo.dataNoticia = notices
                        if(carousel.length != 0){
                          yo.dataCulturaCarousel.push({
                            columna: yo.dataCulturaCarousel.length+1,
                            img: carousel
                          })
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    yo.$toastr.error(response.data['message'], 'Error')
                })
                .finally(function () {

                })
        },
        extractNumber(val){
          let matches = val.match(/\d+/g)
          let chars = val.split(matches)
          return { val: matches, pic: chars }
        },

        async getValues() {
            const yo = this
            yo.dataTableValues = []
            const config = {
                method: 'get',
                url: '/talentoagv/readValues/',
            }

            await axiosIns(config)
                .then(function (response) {
                    // console.log(response.data['result'])
                    if (response.data['is_error'] === false) {
                        let resultado = response.data['result']
                        for (let r of resultado) {
                            if (r['key_idioma_id'] == yo.language) {
                                yo.dataTableValues.push(r)
                            }
                        }
                        // yo.dataTableValues = response.data['result']
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    yo.$toastr.error(response.data['message'], 'Error')
                })
                .finally(function () {

                })
        },

        async getCards() {
            const yo = this
            yo.dataTableCards = []
            const config = {
                method: 'get',
                url: '/talentoagv/readCards/',
            }

            await axiosIns(config)
                .then(function (response) {
                    // console.log(response.data['result'])
                    if (response.data['is_error'] === false) {
                        let resultado = response.data['result']
                        for (let r of resultado) {
                            if (r['key_idioma_id'] == yo.language) {
                                yo.dataTableCards.push(r)
                            }
                        }
                        // yo.dataTableCards = response.data['result']
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    yo.$toastr.error(response.data['message'], 'Error')
                })
                .finally(function () {

                })
        },

        showMenu(toggleId, navId) {
            const toggle = document.getElementById(toggleId),
                nav = document.getElementById(navId)

            toggle.addEventListener('click', () => {
                // Add show-menu class to nav menu
                nav.classList.toggle('show-menu')
                // Add show-icon to show and hide menu icon
                toggle.classList.toggle('show-icon')
            })
        },

        dropdownItemsEvent() {
            const dropdownItems = document.querySelector('.dropdown__container')

            if (dropdownItems.classList.contains('is-active')) {
                dropdownItems.classList.remove('is-active')
            } else {
                dropdownItems.classList.add('is-active');
            }

        },

        toggleImages() {
            setInterval(() => {
                this.currentImageIndex = (this.currentImageIndex + 1) % this.dataImagen.length;
            }, 3000);
        },


        startTypingEffect() {
            this.typingIndex = 0;
            this.typeText();
        },

        typeText() {
            const currentText = this.effectText[this.typingIndex];
            let charIndex = 0;
            const typingInterval = setInterval(() => {
                if (charIndex < currentText.length) {
                    this.currentTypedText += currentText[charIndex];
                    charIndex++;
                } else {
                    clearInterval(typingInterval);
                    setTimeout(() => {
                        this.currentTypedText = ''; // Borrar texto antes de pasar al siguiente
                        this.typingIndex = (this.typingIndex + 1) % this.effectText.length;
                        this.typeText();
                    }, 2000); // Espera antes de mostrar el siguiente texto
                }
            }, this.typingSpeed);
        },

    },
    beforeDestroy() {
        // Limpiar el setInterval cuando se destruya el componente
        if (this.toggleImages) {
            clearInterval(this.toggleImages);
        }
    },
}

</script>

<style>
@media (max-width: 578px) {
    .form-inner {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center; /* Centra el contenido */
        padding:0px !important
    }

    .input-group {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        width: auto;
        padding: 10px;
    }

    .drop-detail,
    .form-control {
        width: 100%;
        text-align: center; /* Centra el texto en el combo */
    }

    .btn-search-home {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 80px !important; /* Ajuste de redondeado */
        width: 50px;
        height: 50px;
        background-color: #4B0082; /* Color de fondo del botón */
    }

    /* Ajuste adicional para que la lupa tenga un mejor aspecto redondeado */
    .btn-search-home i {
        color: white; /* Color del icono */
    }

    .btn-search-home{
        border-top-left-radius: 80px  !important;
        border-bottom-left-radius: 80px !important;
        width: 30% !important;  
    }

    .select2-container{
        margin-left: 90px !important;
        width: 190px !important;
    }
}
@media (max-width: 480px) {

    .drop-detail .form-control .select2-hidden-accessible .select2 .select2-container .select2-container--default{
        width: 190px !important;
    }

    .select2-container{
        margin-left: -50px !important;
        width: 190px !important;
    }

    #selector{
        width: 190px !important;
    }

    .form{
        width: 200% !important;
    }

     .select2{
        width: 190px !important;
    }

    .select2-selection__rendered{
        width: 200px !important;
        margin-left: -25px !important;
    }
}


@media (max-width: 428px) {
    .select2-container{
        margin-left: -50px !important
    }

    .form{
        width: 150% !important;
    }
}


</style>
